import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

const IntegrationOutlined = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: BusinessIconImageProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'path',
        {
          d: 'M8.61702 4.87701H5.76822C4.79166 4.87701 4 5.66867 4 6.64524V9.49404C4 10.4706 4.79166 11.2623 5.76822 11.2623H8.61702C9.59359 11.2623 10.3852 10.4706 10.3852 9.49404V6.64524C10.3852 5.66867 9.59359 4.87701 8.61702 4.87701Z',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.47352",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M8.61702 13.5992H5.76822C4.79166 13.5992 4 14.3908 4 15.3674V18.2162C4 19.1928 4.79166 19.9844 5.76822 19.9844H8.61702C9.59359 19.9844 10.3852 19.1928 10.3852 18.2162V15.3674C10.3852 14.3908 9.59359 13.5992 8.61702 13.5992Z',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.47352",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M17.3704 13.5992H14.5216C13.5451 13.5992 12.7534 14.3908 12.7534 15.3674V18.2162C12.7534 19.1928 13.5451 19.9844 14.5216 19.9844H17.3704C18.347 19.9844 19.1387 19.1928 19.1387 18.2162V15.3674C19.1387 14.3908 18.347 13.5992 17.3704 13.5992Z',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.47352",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M19.0275 6.65513L17.3604 4.98804C16.8233 4.45095 15.9525 4.45095 15.4155 4.98804L13.7484 6.65513C13.2113 7.19221 13.2113 8.06299 13.7484 8.60008L15.4155 10.2672C15.9525 10.8043 16.8233 10.8043 17.3604 10.2672L19.0275 8.60008C19.5646 8.06299 19.5646 7.19221 19.0275 6.65513Z',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.47352",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
    ],
  );

export default IntegrationOutlined;
